// Session-level cache for units responses
export const unitsResponseCache = new Map<string, { units: any[]; totalCount: number }>();

export function buildUnitsCacheKey(params: Record<string, any>): string {
  return JSON.stringify(params, Object.keys(params).sort());
}

export function clearUnitsCache() {
  unitsResponseCache.clear();
}

export function clearUnitsCacheForVin(vin: string) {
  for (const [key, value] of unitsResponseCache.entries()) {
    if (value.units.some((u: any) => u.VIN === vin || u.vin === vin || u.Vin === vin)) {
      unitsResponseCache.delete(key);
    }
  }
}
